import * as React from 'react';
import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import { IUserProfile } from '../../../Models/Profile/IUserProfile';
import { IAppStore } from '../../../Stores/IAppStore';
import { NewOrderView } from './NewOrderView';
import * as Services from '../../../Services/Services';
import { IProfileApi } from '../../../Services/API/Profile/IProfileApi';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { EmptyProfileContact, IProfileContact } from '../../../Models/Profile/IProfileContact';
import { MessageBar, MessageBarType, Stack } from '@fluentui/react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useBoolean } from '@fluentui/react-hooks';
import { IEventApi } from '../../../Services/API/Event/IEventApi';
import { IEvent } from '../../../Models/Event/IEvent';
import { isNumeric, validateEmail } from '../../../Tools/Validation';
import { IAttendee } from '../../../Models/Attendees/IAttendee';
import { IOrderApi } from '../../../Services/API/Order/IOrderApi';
import { IOrder } from '../../../Models/Order/IOrder';

interface INewOrderProps {
    profile: IUserProfile,
}


export const NewOrder: React.FunctionComponent<INewOrderProps> = (props) => {

    const [isLoaded, setIsLoaded] = useBoolean(true);
    const [event, setEvent] = React.useState<IEvent>()
    const [step, setStep] = React.useState(1);
    const [email, setEmail] = React.useState("");
    const [emailChecked, setEmailChecked] = React.useState(false);
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()
    const [contactInfo, setContactInfo] = React.useState<IProfileContact>(EmptyProfileContact());
    const [eventId, setEventId] = React.useState<number>(0);
    const [emailExists, setEmailExists] = React.useState<boolean>()

    const [attendeesOptions, setAttendeesOptions] = React.useState<IAttendee[]>([])
    const [attendeesSelected, setAttendeesSelected] = React.useState<IAttendee[]>([])
    const [orderId, setOrderId] = React.useState<number>();
    const [order, setOrder] = React.useState<IOrder>();
    const propertyChanged = (key: string, value: any) => {

        const contact = { ...contactInfo, [key]: value }

        if (!contact.differentBillingAddress) {
            contact.billingCity = contact.city;
            contact.billingEmail = email;
            contact.billingPostalCode = contact.postalCode;
            contact.billingStreet = contact.street;
        }

        setContactInfo(contact);

    }
    const navigate = useNavigate();
    const [smallScreen, setSmallScreen] = React.useState(window.matchMedia("(max-width: 320px)").matches)
    const [middleScreen, setMiddleScreen] = React.useState(window.matchMedia("(max-width: 470px)").matches) 
    const [eventLoaded, setEventLoaded] = React.useState(false);
    const [acceptPromotion, setAcceptPromotion] = React.useState(true);
    const [acceptMarketing, setAcceptMarketing] = React.useState(true);




    React.useEffect(() => {

        function setCallBackSmallScreen(e: MediaQueryListEvent) {
            setSmallScreen(e.matches)
        }
        function setCallBackMiddleScreen(e: MediaQueryListEvent) {
            setMiddleScreen(e.matches)
        }

        window.matchMedia("(max-width: 320px)").addEventListener('change', setCallBackSmallScreen);
        window.matchMedia("(max-width: 470px)").addEventListener('change', setCallBackMiddleScreen);
        return () => {
            window.matchMedia("(max-width: 320px)").removeEventListener("change", setCallBackSmallScreen);
            window.matchMedia("(max-width: 470px)").removeEventListener('change', setCallBackMiddleScreen);
        }

    }, []);


    React.useEffect(() => {
        if (props.profile?.email != "") {
            setEmail(props.profile?.email);
            loadProfileInfo();
            loadAttendees();
        }
    }, [props.profile])

    const loadAttendees = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
        const attendees = await profileApi.getAttendees();
        if (attendees.isSuccess && attendees.data) {
            setAttendeesOptions(attendees.data);
            setStatusMessage({ message: attendees.message, type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: attendees.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const loadProfileInfo = async () => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const profileApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
        const profile = await profileApi.getProfileContact();
        if (profile.isSuccess && profile.data) {
            setContactInfo(profile.data);
            setStatusMessage({ message: profile.message, type: MessageBarType.success });
        }
        else {
            setStatusMessage({ message: profile.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    const checkEmail = async (email: string) => {
        if (validateEmail(email)) {
            setIsLoading.setTrue();
            setStatusMessage(undefined);

            const eventTypeApi = Services.ServicesProvider.GetService<IProfileApi>(Services.ProfileApi);
            const result = await eventTypeApi.checkEmail(email);
            if (result.isSuccess && result.data != null) {
                setStatusMessage({ message: result.message, type: MessageBarType.success });
                setEmailExists(result.data);
                setEmailChecked(true);
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
            }
            setIsLoading.setFalse();
        }
        else {
            setEmailChecked(false);
        }

    }

    const loadEvent = async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        setEventLoaded(false);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.getEvent(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setEvent(result.data);
            setIsLoaded.setTrue();
            setEventLoaded(true);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
            setIsLoaded.setTrue();
            setEvent(undefined);
            setEventLoaded(true);
        }
       setIsLoading.setFalse();
    }

    const [params, setSearchParams] = useSearchParams();

    React.useEffect(() => {
        if (isLoaded) {
            var step = params.get("step");
            if (step && isNumeric(step)) {
                setStep(Number.parseInt(step));
            }
            else {
                setStep(1);
            }
        }
    }, [params]);

    React.useEffect(() => {
        var step = params.get("step");
        var _eventId = params.get("eventId");
        if (_eventId && isNumeric(_eventId)) {
            setEventId(Number.parseInt(_eventId));
            if (step && isNumeric(step)) {
                setStep(Math.min(Number.parseInt(step), 2));
                setSearchParams({ eventId: _eventId, step: Math.min(Number.parseInt(step), 2).toString() });
            }
            else {
                setSearchParams({ eventId: _eventId, step: "1" });
            }
        }       
    }, []);

    React.useEffect(() => {
        if (eventId != 0) {
            loadEvent(eventId);
        }
    }, [eventId])

    React.useEffect(() => {
        if (props.profile.id === "") {
            setContactInfo({ ...contactInfo, billingEmail: email });
        }
    }, [email]);

    const setOrderSteps = (_step: number) => {
        let newStamp = _step;
        if (props.profile.id !== "") {
            if (_step === 2) {
                newStamp = 3;
            }
        }
        setSearchParams({ eventId: eventId.toString(), step: _step.toString() });
    }

    const addAttendee = (item: IAttendee) => {
        const exists = attendeesOptions.find(x => x.id === item.id);
        if (!exists) {
            setAttendeesOptions([...attendeesOptions, item]);
        }
        setAttendeesSelected([...attendeesSelected, item]);
    }

    const selectAttendee = (item: IAttendee) => {
        setAttendeesSelected([...attendeesSelected, item]);
    }
    const removeSelectedAttendee = (id: number, userId: string) => {
        const r = attendeesSelected.filter(x => x.id !== id);
        setAttendeesSelected(r ? r : []);
    }

    const getOrder = async (id: number) =>
    {
        setIsLoading.setTrue();
        const orderApi = Services.ServicesProvider.GetService<IOrderApi>(Services.OrderApi);
        const result = await orderApi.getOrder(id);
        if (result.isSuccess && result.data) {
            setStatusMessage({ message: result.message, type: MessageBarType.success });
            setOrder(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (orderId) {
            getOrder(orderId);
        }
    }, [orderId]);

    const goBack = () => {
        navigate(-1);
    }

    const finishOrder = async () => {
        if (event) {
            setIsLoading.setTrue();
            const orderApi = Services.ServicesProvider.GetService<IOrderApi>(Services.OrderApi);
            const result = await orderApi.newOrder({
                email: email,
                eventId: event?.id,
                acceptMarketing: acceptMarketing,
                acceptPromotion: acceptPromotion,
                Attendees: attendeesSelected,
                profileContact: contactInfo
            });
            if (result.isSuccess && result.data) {
                setStatusMessage({ message: result.message, type: MessageBarType.success });
                setOrderSteps(7);
                setOrderId(result.data);
                setIsLoaded.setTrue();
            }
            else {
                setStatusMessage({ message: result.message, type: MessageBarType.error });
                setOrderId(undefined);
            }
            setIsLoading.setFalse();
        }
    }

    const updateDoprovodAttendee =  (id: number, value: string) => {
        setAttendeesSelected(attendeesSelected.map(item => {
            if (item.id === id) {
                item.doprovod = value;
            }
            return item;
        }));
    }


    return (
        <Stack tokens={{ padding: smallScreen?0: 15 }} >
            <NewOrderView
                acceptMarketing={acceptMarketing}
                acceptPromotion={acceptPromotion}
                setAcceptMarketing={setAcceptMarketing}
                setAcceptPromotion={setAcceptPromotion}
                finishOrder={finishOrder}
                userId={props.profile.id}
                event={event}
                email={email}
                checkEmail={checkEmail}
                emailChanged={setEmail}
                emailExists={emailExists}
                emailChecked={emailChecked}
                step={step}
                goToStep={setOrderSteps}
                goBack={goBack}
                profileInfo={contactInfo}
                isAuth={props.profile.email !== ""}
                invoiceContantpropertyChanged={propertyChanged}
                isLoading={isLoading}
                attendees={attendeesOptions}
                addAttendee={addAttendee}

                attendeesSelected={attendeesSelected}
                selectAttendee={selectAttendee}
                removeSelectedAttendee={removeSelectedAttendee}
                middleScreen={middleScreen}
                smallScreen={smallScreen}
                order={order}
                statusMessage={statusMessage}
                updateDoprovodAttendee={updateDoprovodAttendee}
            />

            {
                !event && eventLoaded ? <MessageBar messageBarType={MessageBarType.error} > Akce nenalezena</MessageBar> : null
            }
        </Stack>)
}



const EmailChangeToProps = (state: IAppStore) => ({
    profile: state.userProfileStore.profile,

});

const EmailChangeDispatchToProps = (dispatch: ThunkDispatch<IAppStore, any, AnyAction>) => ({

});

export default connect(EmailChangeToProps, EmailChangeDispatchToProps)(NewOrder);

